import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import {Linear, Power3, TimelineMax, TweenMax} from 'gsap/all';
import {environment} from './../../services/util.service';
import { Brand } from '@signal/asp-data-commons';
import { Store } from '@ngrx/store';
import {DealerState} from '../../../store/dealer/dealer.reducer';
import { selectDealerCode } from '../../../store/dealer/dealer.selectors';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() size = 1;
  @Input() text: string;
  @Input() loadingSymbol: string;
  @Input() color: string ;
  @Input() asOverlay: boolean;
  @Input() compact = false;

  /* Toyota vector's paths */
  @ViewChild('pathCenter') pathCenter: ElementRef;
  @ViewChild('pathTop') pathTop: ElementRef;
  @ViewChild('pathOuter') pathOuter: ElementRef;
  loadingToyotaStrokeOuter = '#loading-toyota-stroke-outer';
  loadingToyotaStrokeTop = '#loading-toyota-stroke-top';
  loadingToyotaStrokeCenter = '#loading-toyota-stroke-center';
  loadingLexusStroke = '#loading-lexus-stroke';
  private subsCr : Subscription;

  /* Lexus vector's path */
  @ViewChild('pathLexus') pathLexus: ElementRef;

  constructor(private hostElement: ElementRef,private readonly dealerState: Store<DealerState>,) {
  }

  ngOnInit(): void {
    if (!this.loadingSymbol) {
      this.subsCr = this.dealerState.select(selectDealerCode).subscribe(dealercode=> {
        this.loadingSymbol = Brand.TOYOTA;
        if(dealercode.startsWith('6')){
          this.loadingSymbol = Brand.LEXUS;
        }
      })
    }
  }

  ngAfterViewInit(): void {
    if (this.loadingSymbol === Brand.TOYOTA) {
      setTimeout(()=>{
        this.animateToyota();
      })
    } else if (this.loadingSymbol === Brand.LEXUS) {
      setTimeout(()=>{
        this.animateLexus();
      })
    }
  }

  animateToyota() {
    const lenOuter = this.pathOuter.nativeElement.getTotalLength();
    const lenTop = this.pathTop.nativeElement.getTotalLength();
    const lenCenter = this.pathCenter.nativeElement.getTotalLength();

    TweenMax.set(this.loadingToyotaStrokeOuter, {strokeDasharray: lenOuter});
    TweenMax.set(this.loadingToyotaStrokeTop, {strokeDasharray: lenTop});
    TweenMax.set(this.loadingToyotaStrokeCenter, {strokeDasharray: lenCenter});
    TweenMax.set('#loding-animation', {autoAlpha: 0});

    const tl = new TimelineMax({
      repeat: -1,
      repeatDelay: 0.5,
      ease: Power3.easeOut,
    });

    tl.addLabel('i', 6.5)
      .set(this.loadingToyotaStrokeOuter, {strokeDashoffset: lenOuter})
      .set(this.loadingToyotaStrokeTop, {strokeDashoffset: lenTop})
      .set(this.loadingToyotaStrokeCenter, {strokeDashoffset: lenCenter})
      .set('#loding-animation', {autoAlpha: 1})
      .set(this.loadingToyotaStrokeCenter, {autoAlpha: 0})
      .set(this.loadingToyotaStrokeOuter, {autoAlpha: 0.3})
      .to(this.loadingToyotaStrokeOuter, 0.6, {
        autoAlpha: 1,
        strokeDashoffset: 0,
        ease: Linear.easeOut,
      })
      .to(this.loadingToyotaStrokeTop, 0.35, {strokeDashoffset: 0, ease: Linear.easeOut}, '-=0.05')
      .to(
        this.loadingToyotaStrokeCenter,
        0.35,
        {autoAlpha: 1, strokeDashoffset: 0, ease: Linear.easeIn},
        '-=0.05'
      )
      .to(
        '#loading-toyota-logo',
        0.5,
        {autoAlpha: 0, scale: this.size - 0.02, ease: Linear.easeIn},
        '+=.3'
      );
  }

  animateLexus() {
    const pathLength = this.pathLexus.nativeElement.getTotalLength();

    TweenMax.set(this.loadingLexusStroke, {strokeDasharray: pathLength, autoAlpha: 0.7});
    // TweenMax.set(this.loadingLexusStroke, {autoAlpha: 0.7});

    const tl = new TimelineMax({
      repeat: -1,
      repeatDelay: 0.5,
      ease: Power3.easeOut,
    });

    tl.addLabel('i', 6.5)
      .set(this.loadingLexusStroke, {strokeDashoffset: pathLength})
      .to(this.loadingLexusStroke, 1.2, {
        autoAlpha: 1,
        strokeDashoffset: 0,
        ease: Power3.easeOut,
      })
      .to(
        '#loading-lexus-logo',
        0.4,
        {
          autoAlpha: 0,
          scale: this.size - 0.03,
        },
        '+=.2'
      );
  }

  ngOnDestroy() {
    this.subsCr?.unsubscribe();
  }
}
